import { flow, types, getSnapshot } from "mobx-state-tree"
import Api from '../api/Api'
import State, {pending, error, done, notLoaded} from './State'
import _ from 'lodash'

const AccountList = types.model({
    id: types.number,
    name: types.string,
})
.named('AccountList')

const AccountDetail = types.compose(
    AccountList,
    types.model({
        id: types.number,
        name: types.string,
        users: types.frozen(),
        inventory_alert_recipients: types.array(types.string),
        inventory_alert_limit: types.number,
        saveState: types.optional(State, notLoaded)
    })
    .actions((self)=>({
        addRecipient: (recipient)=>{
            self.inventory_alert_recipients.push(recipient);
        },
        removeRecipient: (recipient)=>{
            self.inventory_alert_recipients = _.filter(self.inventory_alert_recipients, (_recipient)=>_recipient !== recipient);
        },
        setAlertLimit: (limit)=>{
            self.inventory_alert_limit = limit
        },
        save: flow(function* update() {
            self.saveState = pending
            try {
                var snapshot = getSnapshot(self);
                var data = _.pick(snapshot, ['name', 'inventory_alert_recipients', 'inventory_alert_limit'])

                const response = yield Api.patch(`/accounts/${snapshot.id}/`, data);
                self.saveState = done
            } catch (e) {
                console.error(e)
                self.saveState = error
            }
        })
    }))
)
.named('AccountDetail')

const AccountStore = types.model({
    accounts: types.maybe(types.array(AccountList)),
    accountsState: types.optional(State, notLoaded),

    account: types.maybe(AccountDetail),
    accountState: types.optional(State, notLoaded),
})
.actions(self => ({
    fetchAccounts: flow(function* fetchAccounts() {
        self.accounts = undefined
        self.accountsState = pending
        try {
            const response = yield Api.get('/accounts/')
            self.accounts = response.data
            self.accountsState = done
        } catch (e) {
            console.error(e)
            self.accountsState = error
        }
    }),
    fetchAccount: flow(function* fetchAccount(id) {
        self.accountState = pending
        try {
            const response = yield Api.get(`/accounts/${id}/`)
            self.account = response.data
            self.accountState = done
        } catch (e) {
            console.error(e)
            self.accountState = error
        }
    })
}))
.named('AccountStore')

export default AccountStore.create({})


// WEBPACK FOOTER //
// ./src/stores/AccountStore.js